module.exports = __webpack_public_path__ + "static/media/cart.1f985188.svg";